import dataService from 'services/data';

export const SET_BRANDS = '@data/set-brands';
export const SET_MODELS = '@data/set-models';
export const SET_VERSIONS = '@data/set-versions';
export const SET_BRANCHES = '@data/set-branches';
export const GET_BRANDS = '@data/get-brands';
export const SET_YEARS = '@data/set-years';
export const SET_SUBVERSIONS = '@data/set-subversions';
export const SET_ASSOCIATED_REBUYERS = '@data/set-associated_rebuyers';
export const SET_BRANCH_SELLERS = '@data/set-branch-sellers';

export function getBranches() {
  return async (dispatch: any) => {
    try {
      let { branches }: any = await dataService.getCompanyData();
      dispatch({
        type: SET_BRANCHES,
        payload: branches
      });
    } catch (error) {
      dispatch({
        type: SET_BRANCHES,
        payload: []
      });
    }
  };
}

export function getAssociatedRebuyers() {
  return async (dispatch: any) => {
    try {
      let rebuyers = await dataService.getAssociatedRebuyers();
      dispatch({
        type: SET_ASSOCIATED_REBUYERS,
        payload: rebuyers
      });
    } catch (error) {
      dispatch({
        type: SET_BRANCHES,
        payload: []
      });
    }
  };
}

export function setSubversions(data: any) {
  return (dispatch: any) => {
    dispatch({
      type: SET_SUBVERSIONS,
      payload: data
    });
  };
}

export function setYears(data: any) {
  return (dispatch: any) => {
    dispatch({
      type: SET_YEARS,
      payload: data
    });
  };
}

export function setBrands(data: any) {
  return (dispatch: any) => {
    dispatch({
      type: SET_BRANDS,
      payload: data
    });
  };
}
export function setModels(data: any) {
  return (dispatch: any) => {
    dispatch({
      type: SET_MODELS,
      payload: data
    });
  };
}

export function setVersions(data: any) {
  return (dispatch: any) => {
    dispatch({
      type: SET_VERSIONS,
      payload: data
    });
  };
}

export function setBranches(data: any) {
  return (dispatch: any) => {
    dispatch({
      type: SET_BRANCHES,
      payload: data
    });
  };
}

export function getBrands(type: any) {
  return async (dispatch: any) => {
    try {
      let response = await dataService.getBrands(type);
      dispatch({
        type: SET_BRANDS,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: SET_BRANDS,
        payload: []
      });
    }
  };
}

export function getVersions(model: any, year: any, modifyYears = false) {
  return async (dispatch: any) => {
    try {
      let response: any = await dataService.getVersions(model, year);
      dispatch({
        type: SET_VERSIONS,
        payload: response.versions
      });
      if (modifyYears) {
        dispatch({
          type: SET_YEARS,
          payload: response.years
        });
      }
    } catch (error) {
      dispatch({
        type: SET_VERSIONS,
        payload: []
      });
      dispatch({
        type: SET_YEARS,
        payload: []
      });
    }
  };
}

export function getBranchSellers(branch_id: any) {
  return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
    try {
      const response = await dataService.getBranchSellers(branch_id);
      dispatch({
        type: SET_BRANCH_SELLERS,
        payload: response
      });
    } catch (error) {
      dispatch({
        type: SET_BRANCH_SELLERS,
        payload: []
      });
    }
  };
}
